import { Alert, Col, InputField, Label, ModalPopup, PrimaryButton, Row } from 'client/CommonComponents'
import './PurchaseOrder.scss'
import PODetailGrid from '../PODetailGrid'
import CancelConfirmationPopup from 'client/CommonComponents/DialogBox/CancelConfirmationPopup'
import { Spinner } from "@softura/fluentuipackage";
import permissions, { isAuthorized } from 'client/utils/Permissions';
import { CONSTANTS } from 'client/utils/constants';
interface IProps {
    createPOClick: any,
    showCreatePoPopup: any,
    hideCreatePOPopup: any,
    purchaseOrderStepperData?: any,
    handleChange?: any,
    poErrors?: any,
    createPOOnConfirmation?: any,
    setIsButtondisable?: any,
    showLoadingMessage?: any,
    Popupcontent?: any,
    hideDialog?: any,
    desc1OnBlur?: any,
    desc2OnBlur?: any,
    makeOnBlur?: any,
    modelOnBlur?: any,
    poNeedToCreate?: any,
    getPONumber?: any,
    showAlert?: any,
    dismissAlert: () => void
}
const PurchaseOrder = ({ createPOClick,
    showCreatePoPopup,
    hideCreatePOPopup,
    handleChange,
    poErrors,
    purchaseOrderStepperData,
    createPOOnConfirmation,
    setIsButtondisable,
    showLoadingMessage,
    Popupcontent,
    hideDialog,
    desc1OnBlur,
    desc2OnBlur,
    makeOnBlur,
    modelOnBlur,
    poNeedToCreate,
    getPONumber,
    showAlert,
    dismissAlert
 }: IProps) => {

    return (
        <div className="purchaseorder-container">
            <Row>
                <Col xs={12} sm={12} md={6} lg={4} className='mb-3'>
                    <Label required data-attribute="PurchaseOrder_Default_Label_7">PO Description 1</Label>
                    <InputField
                        value={purchaseOrderStepperData?.purchaseOrder?.poDescription1 ?? ""}
                        onChange={handleChange}
                        onBlur={desc1OnBlur}
                        name="poDescription1"
                        placeholder="PO Description 1"
                        className={(poErrors?.poDescription1 ? "controlValidation" : "")}
                        disabled = {purchaseOrderStepperData?.isPOCreated || purchaseOrderStepperData?.fleetRequests?.some((request: any) => request.fleetStatus === CONSTANTS.ORDER_STATUS.CANCELLED)}
                     data-attribute="PurchaseOrder_poDescription1_Input" />
                    {
                        poErrors?.poDescription1 && (
                            <span className="validMessage">
                                {purchaseOrderStepperData?.purchaseOrder?.poDescription1?.length > 30 ? "Please enter PO Description 1 less than 30 characters" : "Please enter PO Description 1"}
                            </span>
                        )
                    }
                </Col>
                <Col xs={12} sm={12} md={6} lg={4} className='mb-3'>
                    <Label data-attribute="PurchaseOrder_Default_Label_2_2">PO Description 2</Label>
                    <InputField
                        value={purchaseOrderStepperData?.purchaseOrder?.poDescription2 ?? ""}
                        onChange={handleChange}
                        onBlur={desc2OnBlur}
                        name="poDescription2"
                        placeholder="PO Description 2"
                        className={(poErrors?.poDescription2 ? "controlValidation" : "")}
                        disabled = {purchaseOrderStepperData?.isPOCreated ||purchaseOrderStepperData?.fleetRequests?.some((request: any) => request.fleetStatus === CONSTANTS.ORDER_STATUS.CANCELLED)}
                     data-attribute="PurchaseOrder_poDescription2_Input" />
                    {
                        poErrors?.poDescription2 && (
                            <span className="validMessage">
                                Please enter PO Description 2 less than 30 characters
                            </span>
                        )
                    }
                </Col>
                <Col xs={12} sm={12} md={6} lg={4} className='mb-3'>
                    <Label data-attribute="PurchaseOrder_Default_Label_3_2">Make</Label>
                    <InputField
                        value={purchaseOrderStepperData?.purchaseOrder?.make ?? ""}
                        onChange={handleChange}
                        onBlur={makeOnBlur}
                        name="make"
                        placeholder="Make"
                        className={(poErrors?.make ? "controlValidation" : "")}
                        disabled = {purchaseOrderStepperData?.isPOCreated || purchaseOrderStepperData?.fleetRequests?.some((request: any) => request.fleetStatus === CONSTANTS.ORDER_STATUS.CANCELLED)}
                     data-attribute="PurchaseOrder_make_Input" />
                    {
                        poErrors?.make && (
                            <span className="validMessage">
                                Please enter Make less than 50 characters
                            </span>
                        )
                    }
                </Col>
                <Col xs={12} sm={12} md={6} lg={4} className='mb-3'>
                    <Label data-attribute="PurchaseOrder_Default_Label_4_2">Model</Label>
                    <InputField
                        value={purchaseOrderStepperData?.purchaseOrder?.model ?? ""}
                        onChange={handleChange}
                        onBlur={modelOnBlur}
                        name="model"
                        placeholder="Model"
                        className={(poErrors?.model ? "controlValidation" : "")}
                        disabled = {purchaseOrderStepperData?.isPOCreated || purchaseOrderStepperData?.fleetRequests?.some((request: any) => request.fleetStatus === CONSTANTS.ORDER_STATUS.CANCELLED)}
                     data-attribute="PurchaseOrder_model_Input" />
                    {
                        poErrors?.model && (
                            <span className="validMessage">
                                Please enter Model less than 50 characters
                            </span>
                        )
                    }
                </Col>
                <Col xs={12} sm={12} md={6} lg={4} className='mb-3'>
                    {(purchaseOrderStepperData?.purchaseDetails?.createUniquePo) ? <Label data-attribute="PurchaseOrder_Default_Label_5_2">PO#</Label> : null}
                    <div className={`PO-number ${purchaseOrderStepperData?.purchaseDetails?.createUniquePo ? "consolidatePO-btn" : "" }`}>
                        {(purchaseOrderStepperData?.purchaseDetails?.createUniquePo) ?
                            <div className="PO-detail me-2">
                                <p><b>{getPONumber("poNumber")}</b></p>
                                <p>{getPONumber("poCreationDate")}</p>
                            </div>
                            : null}
                        <PrimaryButton
                            text="Create PO"
                            disabled={!isAuthorized(permissions?.CreateUpdatePurchaseOrders) || (purchaseOrderStepperData?.isPOCreated && !purchaseOrderStepperData?.isPoPartiallyCreated) || purchaseOrderStepperData?.fleetRequests?.some((request: any) => request.fleetStatus === CONSTANTS.ORDER_STATUS.CANCELLED)}
                            className="poolBtn"
                            onClick={createPOClick}
                         data-attribute="PurchaseOrder_Default_Button" />
                    </div>
                </Col>
                {showAlert?.show ? <Col xs={12} sm={12} md={12} lg={12} className='mb-3'>
                    <Alert
                        className="alert-message-stepper"
                        showAlert={showAlert?.show}
                        dismissAlert={dismissAlert}
                        type={showAlert?.type}
                        text={`${showAlert?.source} ${showAlert?.text}`}
                     data-attribute="PurchaseOrder_Default_Alerts" />
                </Col> : null}
            </Row>
            {
                showCreatePoPopup ?
                    <ModalPopup
                        ShowModalPopupFooter={true}
                        ModalPopupTitle="CREATE PO"
                        ModalPopupType="medium"
                        FooterSecondaryBtnTxt="Cancel"
                        FooterPrimaryBtnTxt="Create PO"
                        closeModalPopup={hideCreatePOPopup}
                        PrimaryBtnOnclick={createPOOnConfirmation}
                        SecondryBtnOnclick={hideCreatePOPopup}
                        ModalPopupName="CreatePO-Popup"
                        isFooterPrimaryBtnDisable = {showLoadingMessage}
                     data-attribute="PurchaseOrder_Default_ModalPopup">
                        {showLoadingMessage ?
                           <p className='poCreateLoader'>< Spinner text="" />
                           <span>Creating purchase order for {poNeedToCreate?.length} items</span>
                           </p> : ""}
                        <PODetailGrid
                            isDisplayInPopUp = {true} 
                            purchaseDetailsItem = {poNeedToCreate}
                            purchaseOrderStepperData={purchaseOrderStepperData}
                            setIsButtondisable={setIsButtondisable}
                            showLoadingMessage={showLoadingMessage} />
                    </ModalPopup> : ''
            }
            <CancelConfirmationPopup
                hideDialog={!Popupcontent.isDialogVisible}
                onDismiss={hideDialog}
                Popupcontent={Popupcontent}
                popupOutlinebtnOnclick={() => Popupcontent?.popupOutlinebtnOnclick()}
                popupPrimarybtnOnclick={() => Popupcontent?.popupPrimarybtnOnclick()}

            />
        </div>
    )
}

export default PurchaseOrder